import { render, staticRenderFns } from "./loginbusiness.vue?vue&type=template&id=f4593644"
import script from "./loginbusiness.vue?vue&type=script&lang=js"
export * from "./loginbusiness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Repos\\StopRiparo_Piattaforma\\Piattaforma.Client\\wwwroot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4593644')) {
      api.createRecord('f4593644', component.options)
    } else {
      api.reload('f4593644', component.options)
    }
    module.hot.accept("./loginbusiness.vue?vue&type=template&id=f4593644", function () {
      api.rerender('f4593644', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ticket/views/loginbusiness.vue"
export default component.exports